import { Fetch } from 'lib';
import { createCatalog } from 'services';

type RequestResponses = Awaited<ReturnType<typeof createCatalog>>;

type RequestParameters = {
  id: string;
};

type RequestBody = Parameters<typeof createCatalog>[number];

const updateCatalog = async (params: RequestParameters, body: RequestBody) =>
  await Fetch<RequestResponses, RequestParameters, RequestBody>({
    url: 'adminCatalog/updateCatalog',
    method: 'PUT',
    params,
    body,
  });

export { updateCatalog };
